import { Cron } from '@modules/common/types';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Box, Stack, Typography } from '@mui/material';
import { OutboundCardFrequencyDurationV2 } from './OutboundCardFrequencyDurationV2';

interface OutboundCardFrequencyProps {
  savedCronValue: Cron;
  cronSchedule: Cron | undefined;
  setCronSchedule: (cronValue: Cron) => void;
  shouldShowRealtimeFrequency: boolean;
  children?: React.ReactNode;
}

export const OutboundCardFrequency = ({
  children,
  savedCronValue,
  cronSchedule,
  setCronSchedule,
  shouldShowRealtimeFrequency,
}: OutboundCardFrequencyProps) => {
  return (
    <>
      <Stack direction="row">
        <AccessTimeIcon sx={{ opacity: 0.5 }} />
        <Typography pl={2}>Set Frequency</Typography>
      </Stack>
      <Stack pl={2}>
        <Box pl={3} sx={{ opacity: 0.5 }}>
          {children}
        </Box>
        <Stack pl={3}>
          <Box pt={1}>
            <Typography variant="caption" color="text.secondary">
              When do you want to receive your report?
            </Typography>
          </Box>
          <OutboundCardFrequencyDurationV2
            savedCronValue={savedCronValue}
            cronSchedule={cronSchedule}
            setCronSchedule={setCronSchedule}
            shouldShowRealtimeFrequency={shouldShowRealtimeFrequency}
          />
        </Stack>
      </Stack>
    </>
  );
};
